import { SearchSlash } from 'lucide-react';

import Loader from '@/components/common/Loader';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import UpcomingClientBookings from './clientList/UpcomingClientBookings';
import NextClientBookings from './clientList/NextClientBookings';
import CoachClientTabs from './CoachClientTabs';

import { useSelfClientBookingPage } from '@/data/booking';
import { useSelf } from '@/data/user';

const BookingsList = () => {
  const clientBookings = useSelfClientBookingPage();
  const self = useSelf();

  if (clientBookings.isLoading && !clientBookings.data) {
    return (
      <div className="h-screen max-h-[30vh] flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {self.data.coach && <CoachClientTabs />}
      <div className="space-y-4 pb-20">
        <>
          {clientBookings.data.upcomingBookings.length === 0 ? (
            <div className="flex justify-center items-center h-[240px]">
              <Empty>
                <EmptyIcon>
                  <SearchSlash />
                </EmptyIcon>
                <EmptyTitle>No Bookings Found</EmptyTitle>
                <EmptyDescription className="max-w-[300px]">
                  You don&apos;t have any upcoming bookings in the next 2 weeks
                </EmptyDescription>
              </Empty>
            </div>
          ) : (
            <>
              <UpcomingClientBookings />
              <NextClientBookings />
            </>
          )}
        </>
      </div>
    </>
  );
};

export default BookingsList;
